import React from 'react';
import { ItemsDto } from '../../../../../types/items';
import { useTranslation } from '../../../../../contexts/I18nProvider';
import { formatQty } from '../format';
import { DataPanel, DataRow } from './DataPanel';

interface ItemBasicInfoSectionProps {
  item: ItemsDto;
  /** Lagersjef: vis innkjøpspris (API sender den ikke til operatør). */
  showPrice: boolean;
}

/**
 * Grunndata (begge roller), delt i tre paneler: grunndata, klassifisering og toll/frakt.
 * Alle felt vises alltid — tomme dempet («–»). Innkjøpspris kun for lagersjef.
 */
export const ItemBasicInfoSection: React.FC<ItemBasicInfoSectionProps> = ({ item, showPrice }) => {
  const { t } = useTranslation();
  const k = (key: string, fallback: string) => t(`warehouse.modules.itemCard.basicInfo.${key}`, {}, fallback);

  const unit = item.itemUnitCode
    ? (item.itemUnitTxt ? `${item.itemUnitCode} — ${item.itemUnitTxt}` : item.itemUnitCode)
    : item.itemUnitTxt;
  const currency = item.currency && item.currency !== 'NULL' ? item.currency : '';

  return (
    <>
      <DataPanel title={k('title', 'Grunndata')}>
        <DataRow label={k('unit', 'Enhet')} value={unit} />
        <DataRow label={k('unitFactor', 'Faktor')} value={item.unitFactor ? formatQty(item.unitFactor) : null} />
        <DataRow label={k('supplierItemNo', 'Leverandørens varenr')} value={item.supplierItemNo} mono />
        {showPrice && (
          <DataRow
            label={k('purchasePrice', 'Innkjøpspris')}
            value={item.purchasePrice != null ? `${formatQty(item.purchasePrice)} ${currency}`.trim() : null}
          />
        )}
      </DataPanel>

      <DataPanel title={k('classification', 'Klassifisering')}>
        <DataRow label={k('itemGroup1', 'Varegruppe 1')} value={item.itemGrp1} />
        <DataRow label={k('itemGroup2', 'Varegruppe 2')} value={item.itemGrp2} />
        <DataRow label={k('itemGroup3', 'Varegruppe 3')} value={item.itemGrp3} />
      </DataPanel>

      <DataPanel title={k('customs', 'Toll og frakt')}>
        <DataRow label={k('hsCode', 'HS-kode')} value={item.hsCode} mono />
        <DataRow label={k('countryOfOrigin', 'Opprinnelsesland')} value={item.countryOfOrigin} />
        <DataRow label={k('grossWeight', 'Bruttovekt (kg)')} value={item.grossWeight != null ? formatQty(item.grossWeight) : null} />
      </DataPanel>
    </>
  );
};
